<template>
    <div id="messagedetail">
        <div msg-title>
            {{msgDetail.Title}}
        </div>
        <div msg-desc>
            {{msgDetail.Descreiption}}
        </div>
        <div msg-imgtxt v-for="it in msgPicTxt">
            <div msg-img>
                <img v-if="it.FileId!=0" :src="baseUrl+'/File/PreView/'+it.FileId" alt="">
            </div>
            <div msg-txt v-html="it.Txt"></div>
        </div>
    </div>
</template>

<script>
    import { getMessageDetail, imgServerHost } from "../../api/api";
    import store from "../../utils/storage";

    export default {
        name: "Login",
        data() {
            return {
                msgDetail: {},
                msgPicTxt: [],
                baseUrl: imgServerHost(),
                queryParams: {
                    pid: this.$route.params.pid,
                    uid: this.$route.params.uid
                }
            };
        },
        mounted() {
            this.getMessageDetail();
        },
        methods: {
            getMessageDetail() {
                getMessageDetail(this.queryParams).then(res => {
                    if (res.data.Code != 1) return;
                    this.msgDetail = res.data.Data;
                    if (this.msgDetail.TpImgTxts) 
                        this.msgPicTxt = JSON.parse(this.msgDetail.TpImgTxts);
                });
            }
        }
    }
</script>


<style scoped>
    @import "../../assets/css/infoData/messagedetail.css";
</style>


// WEBPACK FOOTER //
// src/components/infoData/MessageDetail.vue